import { useEffect, useRef } from 'react';
import DetailPageSectionHeader from 'components/elements/DetailPageSectionHeader';
import copy from 'config/copy';
import RecipeIngredientGroup from '../RecipeIngredientGroup';
import { useRecipeDetails } from 'contexts/RecipeDetailContext';
import styles from './RecipeIngredientGroups.module.scss';
import { IngredientGroups } from 'types/api/recipe.types';
import { PrintFontOptions } from 'types/recipe';
import { Heading } from '@americastestkitchen/mise';

export type RecipeIngredientGroupsProp = {
  ingredientGroups: IngredientGroups[];
  viewContext: 'quick-view' | 'main' | 'print';
  printSize?: PrintFontOptions;
};

const RecipeIngredientGroups: React.FC<RecipeIngredientGroupsProp> = ({
  ingredientGroups,
  viewContext,
  printSize,
}) => {
  const { updateRecipeDetailRef } = useRecipeDetails();
  const titleKey = viewContext === 'main' ? 'ingredientsTitle' : 'ingredients';
  const localIngredientsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    updateRecipeDetailRef(localIngredientsRef, 'ingredients');
  }, [updateRecipeDetailRef]);

  return (
    <div ref={localIngredientsRef} className={styles.container}>
      {ingredientGroups && (
        <div className={styles.group}>
          {viewContext === 'quick-view' ? (
            <Heading as="h4" className={styles.header}>
              {copy.recipes[titleKey]}
            </Heading>
          ) : (
            <DetailPageSectionHeader section="ingredients" />
          )}
          {ingredientGroups.map((recipeIngredientGroup) => (
            <RecipeIngredientGroup
              recipeIngredientGroup={recipeIngredientGroup}
              key={`${viewContext}-ingredients-group-${recipeIngredientGroup.id}`}
              viewContext={viewContext}
              printSize={printSize}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default RecipeIngredientGroups;
